import React, { Component } from 'react';

export default class Navbar extends Component{
//constructor

//functions

  render() {
    return(
      <div className="topnav">What Can I Make?</div>
    )
  }
}
